<form [formGroup]="editAccountForm" *ngIf="!isLoading else loadingView">
    <acabim-form-block
            labelWidth="10"
            [labelAlign]="'right'"
            [shortFields]="true"
            [colonize]="true">
        <acabim-form-input-wrapper *ngIf="accountDetail">
            <acabim-form-input-label>Status</acabim-form-input-label>
            <acabim-form-input-content>
                <p-checkbox formControlName="status" [binary]="true"></p-checkbox>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper *ngIf="accountDetail">
            <acabim-form-input-label>Account ID</acabim-form-input-label>
            <acabim-form-input-content>
                {{accountDetail ? accountDetail.id : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Identifier/Code</acabim-form-input-label>
            <acabim-form-input-content>
                <input formControlName="identifier" type="number" placeholder="Enter an account identifier">
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Name</acabim-form-input-label>
            <acabim-form-input-content>
                <input type="text" formControlName="name" id="name" placeholder="Enter an account name"/>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Description</acabim-form-input-label>
            <acabim-form-input-content [longField]="true">
                <acabim-text-area class="w-100" [formGroup]="editAccountForm" controlName="description"></acabim-text-area>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Class</acabim-form-input-label>
            <acabim-form-input-content>
                <p-dropdown
                    formControlName="class"
                    [options]="classes"
                    placeholder="Select account class"
                    optionLabel="name"></p-dropdown>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Account type</acabim-form-input-label>
            <acabim-form-input-content>
                <p-dropdown
                    formControlName="accountType"
                    [options]="accountTypes"
                    placeholder="Select account type"
                    optionLabel="name"></p-dropdown>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Value Type</acabim-form-input-label>
            <acabim-form-input-content>
                <p-dropdown
                    formControlName="valueType"
                    [options]="valueTypes"
                    placeholder="Select Value Type"
                    optionLabel="name"></p-dropdown>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
    </acabim-form-block>
</form>
<div class="cas-action-buttons cas-action-buttons-bottom">
    <button class="cas-button-action cas-button-right" (click)="onSubmit()">UPDATE</button>
</div>

<p-toast position="center"></p-toast>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
